










import {
  apiEvaluationEvaluateList,
  apiEvaluationEvaluateStoreList,
} from '@/api'
import { BookCommentComponents } from '../comment/components'
import { defineClassComponent, useQuery } from '@/hooks'
import { requiredDeep, Track } from '@/utils'
import { XWaterfallLoad } from '@/components'

export default defineClassComponent(
  {
    components: BookCommentComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '网友评价',
        }))
      }

      query = useQuery<{
        martId: string
        goodsId: string
      }>()

      handleLoad: XWaterfallLoad = ({ pageNumber }) => {
        return this.query.martId
          ? apiEvaluationEvaluateStoreList({
              storeId: this.query.martId,
              havingPicFlag: 0,
              pageIndex: pageNumber,
              pageSize: 10,
            }).then(requiredDeep)
          : apiEvaluationEvaluateList({
              commodityServiceId: this.query.goodsId,
              havingPicFlag: 0,
              pageIndex: pageNumber,
              pageSize: 10,
            }).then(requiredDeep)
      }
    },
)
